import CustomLoadingButton from 'Components/CustomLoadingButton'
import {
  ReportGenerationStatus,
  type ReportGenerationStatusShape
} from 'Services/SalesManagement/Features/Report/reportSlice'
import DownloadReportIcon from '@mui/icons-material/CloudDownload'
import Box from '@mui/material/Box'
import { useEffect } from 'react'
import { t } from 'ttag'

const handleReportDownload = (singleReport: string, reportName: string | null | undefined) => {
  const blob = new Blob([singleReport])
  const tempLink = document.createElement('a')
  tempLink.href = window.URL.createObjectURL(blob)
  const reportFileName = reportName ?? 'order-report'
  tempLink.setAttribute('download', `${reportFileName}.csv`)
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
}

interface ReportDownloadProps {
  singleReport: string | null
  reportGenerationStatus: ReportGenerationStatusShape | null
  fetchReport: (reportName: string) => void
  isLoading: boolean
}

export default function ReportDownload({
  singleReport,
  reportGenerationStatus,
  fetchReport,
  isLoading
}: Readonly<ReportDownloadProps>) {
  /**
   * Effect to handle report fetching when the report generation status changes to SUCCESS.
   */
  useEffect(() => {
    // Only fetch the report if it has not been fetched yet
    if (!singleReport) {
      // Check if the report generation was successful
      if (reportGenerationStatus?.status === ReportGenerationStatus.SUCCESS) {
        // If a report name is available in the report generation status, fetch the report
        if (reportGenerationStatus?.info?.report_name) {
          fetchReport(reportGenerationStatus.info.report_name)
        }
      }
    }
  }, [reportGenerationStatus?.status, singleReport])

  return (
    <Box sx={{ my: 4, display: 'flex', justifyContent: 'end' }}>
      {singleReport != null && (
        <CustomLoadingButton
          isLoading={isLoading}
          onClick={() =>
            handleReportDownload(singleReport, reportGenerationStatus?.info?.report_name)
          }
          icon={<DownloadReportIcon />}
          iconPosition="start"
        >
          {t`Download report`}
        </CustomLoadingButton>
      )}
    </Box>
  )
}
